<template>
  <div class="home">
    <div class="logo"></div>
    <div class="header">
      <span> <i>家在唐镇 暖心社区</i> </span>
    </div>
    <div class="main">
      <div class="tuijian">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: ac === index }"
            v-for="(item, index) in tabData"
            @click="tabCli(item, index)"
            :key="item.name"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>

      <div class="list">
        <div class="item" v-for="item in list" :key="item.name">
          <div class="img">
            <img :src="item.img[0]" alt="" />
            <p>容纳人数：20人</p>
          </div>

          <div class="info">
            <h3>{{ item.name }}</h3>
            <div class="desc">{{ item.desc }}</div>

            <p class="address">地址：{{ item.address }}</p>
            <p class="time">服务时间：{{ item.time }}</p>
            <p class="user">联系人：{{ item.user }}</p>
            <p class="phone">联系电话：{{ item.mobile }}</p>
          </div>
        </div>
      </div>
      <div class="detail" v-if="isInfo">
        <span class="close" @click="isInfo = false"></span>

        <div class="bg">
          <div class="img">
            <img :src="acSData.img" alt="" srcset="" />
          </div>
          <div class="txt">
            <h4>{{ acSData.name }}</h4>
            <p class="address">{{ acSData.address }}</p>
            <div>
              <p class="s-l">
                <span class="c-time">开放时间：</span><i>{{ acSData.time }}</i>
              </p>
            </div>

            <p class="s-l">
              <span class="c-phone">联系方式：</span><i>{{ acSData.mobile }}</i>
            </p>
            <p class="s-l">
              <span class="c-user">联系人：</span><i>{{ acSData.user }}</i>
            </p>
            <p class="desc"><span>简介：</span>{{ acSData.desc }}</p>
            <div class="serve">
              <div
                class="serve-item"
                v-for="item in acSData.serve"
                :key="item.name"
              >
                <img :src="item.icon" alt="" srcset="" />
                <p>{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="container" class="map"></div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader"
// @ is an alias to /src
import { _isMobile } from "@/utils/util"
import { data } from "@/utils/data"
import { data1 } from "@/utils/data1"
export default {
  name: "Home",
  components: {},
  data() {
    return {
      map: {},
      ac: 0,
      acData: {},
      acSData: {},
      tabData: [
        {
          name: "全部",
        },
        {
          name: "政治",
        },
        {
          name: "服务",
        },
        {
          name: "治理",
        },
      ],
      list: data1,
      serve: [
        {
          icon: "https://pic.netbian.com/uploads/allimg/240721/001822-1721492302c5d4.jpg",
          name: "应急药箱",
        },
        {
          icon: "https://pic.netbian.com/uploads/allimg/240721/001822-1721492302c5d4.jpg",
          name: "应急药箱",
        },
        {
          icon: "https://pic.netbian.com/uploads/allimg/240721/001822-1721492302c5d4.jpg",
          name: "无线网络",
        },
        {
          icon: "https://pic.netbian.com/uploads/allimg/240721/001822-1721492302c5d4.jpg",
          name: "冷热饮水",
        },
        {
          icon: "https://pic.netbian.com/uploads/allimg/240721/001822-1721492302c5d4.jpg",
          name: "应急充电",
        },
      ],
      isInfo: false,
    }
  },
  created() {
    this.initMap()
  },
  methods: {
    tabCli(item, index) {
      this.ac = index
    },
    initMap() {
      AMapLoader.load({
        key: "744a8f67f97df2af0bebaf0141fb937d", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [],
      }).then(() => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          zooms: _isMobile() ? [10, 20] : [10, 20],
          zoom: _isMobile() ? 12 : 14,
          center: [121.655819, 31.235469],
          pitch: 70, // 地图俯仰角度，有效范围 0 度- 83 度
          viewMode: "2D", // 地图模式,
        })
        this.addMaker()
      })
    },
    addMaker() {
      this.list.forEach((e) => {
        let markerContent = `<div class="s-item">
          <img src="${e.img[0]}"/>
          <span>${e.name}</span>
          </div>`
        let marker = new AMap.Marker({
          position: new AMap.LngLat(e.lng, e.lat),
          content: markerContent,
          anchor: "top-center",
          offset: new AMap.Pixel(0, -63),
        })
        marker.data = e
        this.map.add(marker)
        let _this = this
        marker.on("click", function (w) {
          _this.acData = w.target.data
          let arr = data.filter((e) => e.name === _this.acData.service)
          if (arr.length > 0) {
            _this.acSData = arr[0]
          }
          _this.isInfo = true
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100vh;
}
.header {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  height: 237px;
  width: 100%;
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(232, 8, 7, 0.42) 0%,
    rgba(232, 8, 7, 0) 100%
  );
  span {
    position: relative;
    display: inline-block;
    margin-top: 58px;
    width: 752px;
    height: 72px;
    line-height: 72px;
    text-align: center;
    background: linear-gradient(
      90deg,
      rgba(243, 0, 0, 0) 0%,
      #ea0000 51%,
      rgba(226, 0, 0, 0) 100%
    );

    i {
      position: relative;
      z-index: 11;
      font-style: normal;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
    }
  }
  span::after {
    content: "";
    position: absolute;
    top: 35px;
    left: 50px;
    width: 120px;
    height: 1px;
    background: rgba(255, 255, 255, 0.6);
    z-index: 10;
  }
  span::before {
    content: "";
    position: absolute;
    top: 35px;
    right: 50px;
    width: 120px;
    height: 1px;
    background: rgba(255, 255, 255, 0.6);
    z-index: 10;
  }
}
.logo {
  position: fixed;
  top: 46px;
  right: 72px;
  width: 122px;
  height: 122px;
  background: #fff;
  border-radius: 42px;
}
.main {
  position: fixed;
  width: 596px;
  background: #fff;
  border-radius: 20px;
  top: 65px;
  left: 20px;
  bottom: 40px;
  z-index: 99;
  overflow: hidden;
  .tuijian {
    height: 64px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.08) 0%,
      #ffe4dd 47%,
      #ffffff 95%
    );
    margin-bottom: 20px;
  }
  .tabs {
    display: flex;
    width: 500px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 10px;
    .tab {
      flex: 1;
      padding-top: 8px;
      text-align: center;
      box-sizing: border-box;
      cursor: pointer;

      span {
        display: block;
        font-size: 24px;
        color: #666666;
        line-height: 28px;
      }
    }
    .tab:last-child {
      margin-right: 0;
    }
    .active {
      position: relative;
      span {
        color: #de290f;
      }
      span::before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 3px;
        background: #de290f;
        border-radius: 4px 4px 4px 4px;
        position: absolute;
        left: 50%;
        margin-left: -8px;
        bottom: -8px;
      }
    }
  }
  .list::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .list {
    height: calc(100% - 100px);
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .item {
      display: flex;
      margin-bottom: 20px;
      padding: 0 20px;
      .img {
        width: 200px;
        height: 164px;
        object-fit: cover;
        margin-right: 16px;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        p {
          position: absolute;
          width: 100%;
          height: 48px;
          line-height: 48px;
          left: 0;
          bottom: 0;
          background: linear-gradient(
            360deg,
            rgba(0, 0, 0, 0.8) 1%,
            rgba(0, 0, 0, 0) 100%
          );
          position: absolute;
          text-align: center;
          font-size: 16px;
          color: #ffffff;
        }
      }
      .info {
        flex: 1;
        h3 {
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          margin-bottom: 4px;
        }
        p {
          font-size: 14px;
          color: #606366;
          margin-bottom: 6px;
          padding-left: 20px;
        }
        .address {
          background: url(../assets/img/address.png) no-repeat left center;
          background-size: 14px;
        }
        .time {
          background: url(../assets/img/time.png) no-repeat left center;
          background-size: 14px;
        }
        .user {
          background: url(../assets/img/user.png) no-repeat left center;
          background-size: 14px;
        }
        .phone {
          background: url(../assets/img/phone.png) no-repeat left center;
          background-size: 14px;
        }
        .desc {
          font-size: 14px;
          color: #333333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          margin-bottom: 10px;
        }
      }
    }
  }
}

/deep/.s-item {
  white-space: nowrap;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 5px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 22px 22px 22px 22px;
  border: 1px solid #ffffff;
  position: relative;
  img {
    display: inline-block;
    width: 33px;
    height: 33px;
    border: 2px solid #cc0500;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
  }
}
/deep/ .s-item::after {
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -13px;
  bottom: -25px;
  border: 14px solid transparent;
  border-top-color: #fff;
}
/deep/ .s-item::before {
  display: inline-block;
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -4px;
  bottom: -25px;
  width: 8px;
  height: 8px;
  background: #cc0500;
  border-radius: 50%;
}
/deep/ .s-item span {
  font-weight: bold;
  font-size: 18px;
  color: #333333;
  display: inline-block;
  padding-right: 5px;
}
.detail {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  top: 0;
  left: 0;
  .close {
    position: fixed;
    top: 84px;
    right: 84px;
    display: inline-block;
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.8) url(../assets/close.png) no-repeat center;
    background-size: 28px;
    border-radius: 50%;
    cursor: pointer;
  }
  .bg {
    margin: 100px auto;
    width: 1042px;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    .txt {
      padding: 0 20px 20px 20px;
    }
    .img {
      width: 100%;
      height: 580px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    h4 {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      margin-top: 12px;
    }
    .address {
      font-size: 16px;
      color: #606366;
      margin-top: 6px;
      padding-left: 20px;
      background: url(../assets/address.png) no-repeat left center;
      background-size: 14px;
    }
    .s-l {
      display: inline-block;
      margin-top: 6px;
      margin-right: 5px;
      .c-time {
        padding-left: 20px;
        background: url(../assets/c-time.png) no-repeat left center;
        background-size: 16px;
      }
      .c-phone {
        padding-left: 20px;
        background: url(../assets/c-phone.png) no-repeat left center;
        background-size: 16px;
      }
      .c-user {
        padding-left: 20px;
        background: url(../assets/c-user.png) no-repeat left center;
        background-size: 16px;
      }
      span {
        font-weight: bold;
        font-size: 16px;
        color: #cc0500;
      }
      i {
        font-size: 16px;
        color: #333;
        font-style: normal;
      }
    }
    .desc {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      margin-top: 6px;
      span {
        font-weight: bold;
      }
    }
    .serve {
      display: flex;
      margin-top: 6px;
      .serve-item {
        margin-right: 16px;
        text-align: center;
        img {
          width: 24px;
          height: 24px;
          object-fit: cover;
        }
        p {
          margin-top: 6px;

          font-size: 12px;
          color: #333333;
        }
      }
    }
  }
}
/deep/ .amap-logo {
  display: none !important;
}
/deep/ .amap-copyright {
  display: none !important;
}
</style>
